<template>
    <div class="speech">
        <p id="restore">言语康复服务</p>
        <span>采用AI智能语音技术对发音水平进行测试，了解自己的发音水平，并提供专业的言语康复方案，</span><br>
        <span>通过拼音、词语、句子、文章四大板块，提高言语障碍群体的普通话发音水平</span>
        <img src="../assets/rehabitation/intelligent_test_2x.png" style="margin:100px 0 150px;">
        <div id="train" class="reTitle">
            <span>四大言语训练板块</span><br>
            <span>听说结合，趣味康复</span>
        </div>
        <div id="rehabitation">
            <div style="margin-top:20%;">
                <img src="../assets/rehabitation/pinyin_2x.png"><br>
                <span>拼音练习</span>
            </div>
            <div class="left">
                <img src="../assets/rehabitation/word_train_2x.png"><br>
                <span>词语联系</span>
            </div>
            <div>
                <img src="../assets/rehabitation/sentence_2x.png"><br>
                <span>句子练习</span>
            </div>
            <div class="left" style="margin-bottom:10%;">
                <img src="../assets/rehabitation/article_2x.png"><br>
                <span>文章练习</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'speechRehabitationService'
}
</script>

<style scoped>
.speech{
    width:75vw;
    margin-top: 15%;
    text-align: left;
}
.speech img{
    width:100%;
}
.speech p{
    font-size:2.5em;
    font-weight:400;
}
.speech>span{
    font-size:1.3em;
    color:gray;
    line-height:1.5;
}
.reTitle>span{
    font-size:3em;
    font-weight:500;
    color:lightgrey;
    letter-spacing:3px;
    line-height:2.0;
}
.reTitle span:last-child{
    font-size:2em;
}
#rehabitation{
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: flex-end;
}
#rehabitation img{
    width:80%;
    margin:-30% 0 3%;
}
#rehabitation .left{
    align-self: flex-start;
}
#rehabitation div{
    width:50%;
    height:auto;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    align-items: center;
}
#rehabitation div span{
    font-size: 2em;
    font-weight: bold;
}
@media screen and (max-width:700px){
    .speech p{
        font-size: 2em;
    }
    .speech >span{
        font-size: 1em;
    }
    .reTitle>span{
        font-size: 2em;
    }
    .reTitle span:last-child{
        font-size: 1.5em;
    }
    #rehabitation div span{
        font-size: 1.3em;
        font-weight: 550;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/speechRehabitationService.vue